// Test IDs for the Meridian landing page. Kebab-case, function-driven.
export const LANDING = {
  // Header
  header: "site-header",
  logoLink: "logo-link",
  navServices: "nav-services",
  navProcess: "nav-process",
  navTestimonials: "nav-testimonials",
  navFaq: "nav-faq",
  ctaHeaderQuote: "header-cta-quote",
  mobileMenuToggle: "mobile-menu-toggle",
  // Hero
  hero: "hero-section",
  heroCtaQuote: "hero-cta-quote",
  heroCtaTalk: "hero-cta-talk",
  // Services
  services: "services-section",
  serviceCard: (slug) => `service-card-${slug}`,
  // Process
  process: "process-section",
  // Trust marquee
  trustMarquee: "trust-marquee",
  // Testimonials
  testimonials: "testimonials-section",
  testimonialCard: (idx) => `testimonial-card-${idx}`,
  // FAQ
  faq: "faq-section",
  faqItem: (idx) => `faq-item-${idx}`,
  // Quote form
  quoteForm: "quote-form",
  quoteFormStepIndicator: "quote-form-step-indicator",
  quoteFormNext: "quote-form-next",
  quoteFormBack: "quote-form-back",
  quoteFormSubmit: "quote-form-submit",
  quoteFormCompany: "quote-form-company",
  quoteFormIndustry: "quote-form-industry",
  quoteFormEmployees: "quote-form-employees",
  quoteFormProduct: (slug) => `quote-form-product-${slug}`,
  quoteFormStartDate: "quote-form-start-date",
  quoteFormCarrier: "quote-form-carrier",
  quoteFormContactName: "quote-form-contact-name",
  quoteFormEmail: "quote-form-email",
  quoteFormPhone: "quote-form-phone",
  quoteFormNotes: "quote-form-notes",
  quoteFormSuccess: "quote-form-success",
  // Contact
  contactSection: "contact-section",
  contactForm: "contact-form",
  contactName: "contact-name",
  contactEmail: "contact-email",
  contactCompany: "contact-company",
  contactMessage: "contact-message",
  contactSubmit: "contact-submit",
  contactSuccess: "contact-success",
  // Footer
  footer: "site-footer",
};
